import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  margin-right: 8px;
  margin-left: 8px;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  cursor: pointer;
  background: #ffffff;
  color: black;
`;

function ToolbarItem({ Icon, onClick }: IToolbarItem) {
    return <Wrapper onClick={onClick ? onClick : undefined}>{Icon}</Wrapper>;
}

export interface IToolbarItem {
    Icon: React.ReactChild;
    onClick?: () => void;
}

export default ToolbarItem;
